import React from 'react';
import {
    Row, Col, Form,
} from 'antd';
import StyledInput from '../CustomAntdComponents/StyledInput';
import { useAuthStore } from '../../store/auth/authStore';

function PromoCodeInput() {
    const { creditApplied } = useAuthStore();
    return (
        <Row gutter={[16, 8]}>
            <Col xs={24} lg={18}>
                <Form.Item
                    name="promoCode"
                >
                    <StyledInput placeholder="Enter promo code" disabled={creditApplied} />
                </Form.Item>
            </Col>
        </Row>
    );
}

export default PromoCodeInput;
